import React, { useLayoutEffect, useMemo, useState } from 'react';
import styled from '@emotion/styled';

import { TRowData } from 'types/rowDefs';
import { TValue, TCellRenderTemplate } from 'types/columnDefs';

/* ======================================== */

type TProps = {
    value: TValue;
    onClick: ((data: TRowData) => void) | undefined;
    data: TRowData | undefined;
    cellElement: HTMLTableCellElement;
};

const StyledSpan = styled.span(
    () => ({
        color: '#1101be',
        cursor: 'pointer',
        pointerEvents: 'all'
    })
);

/* ======================================== */

/**
 * @private
 */
export const CellLink: React.FC<TProps> = (props) => {
    const onClick = useMemo(() => {
        return props.onClick && props.data ? () => props.onClick!(props.data!) : undefined;
    }, [props.onClick, props.data]);

    //const [title, setTitle] = useState<string | undefined>();

    //useLayoutEffect(() => {
    //    if (props.cellElement && props.value && props.cellElement.scrollWidth > props.cellElement.clientWidth) {
    //        setTitle(props.value.toString());
    //    } else {
    //        setTitle(undefined);
    //    }
    //}, [props.cellElement?.scrollWidth, props.value, props]);

    return (
        <StyledSpan
            onClick={onClick}
            title={props.value.toString()}
        >
            {props.value}
        </StyledSpan>
    );
};
